module.exports = __webpack_public_path__ + "img/apple_pie.5789e0da.jpg";